import ApiService from './api.service';
import TokenService from './token.service';
import { UserDTO } from '@/models/UserDTO';
import { PUBLIC_ROOT_API } from '@/config/app.config';
import LocalStoreService from '@/store/local.store';
import router from '@/router';
import { ActionTypes } from '@/store-vuex/types';

export default class UserService {

  /**
   * Login the user
   * @param username The username of a Pro user
   * @param password The password
   * @returns {UserDTO} A UserDTO object containing minimal user data.
   */
  public static async login(username: string, password: string) {
    const requestData = {
      url: `${PUBLIC_ROOT_API}/Users/authenticate`,
      data: {
        username,
        password,
      },
    };

    return await ApiService.post(requestData.url, requestData.data)
      .then((response: any) => {
        LocalStoreService.setItem(LocalStoreService.localItemKeys.screeningUnit, response.data.suId);
        return response.data as UserDTO;
      });
  }

  /**
   * Logout the current user by calling the API in order to expire the cookies.
   * It also removes the token from storage and XSRF token from header.
   * @returns {Promise} A promise
   */
  public static async logout(): Promise<any> {
    const requestData = {
      url: `${PUBLIC_ROOT_API}/Users/logout`,
    };

    await ApiService.post(requestData.url, {})
      .then((response: any) => {
        this.logoutFromFrontend();
      });
  }

  /**
   * Logout the current user by removing the token from storage and XSRF token from header.
   */
  public static logoutFromFrontend(): void {
    TokenService.removeToken();
    ApiService.removeHeader(TokenService.X_XSRF_TOKEN);
    LocalStoreService.deleteItem(LocalStoreService.localItemKeys.screeningUnit);
    this.clearProData();
  }

  /**
   * Saves the newly created password to DB.
   * @param username The username of a Pro user
   * @param oldPassword The old password
   * @param newPassword The new password
   * @returns {Promise} A promise
   */
  public static async saveNewPassword(username: string, oldPassword: string, newPassword: string): Promise<any> {
    const requestData = {
      url: `${PUBLIC_ROOT_API}/Users/SaveNewPassword`,
      data: {
        username,
        oldPassword,
        newPassword,
      },
    };

    await ApiService.put(requestData.url, requestData.data);
  }

  /**
   * Update terms acceptance date to the user
   * @param username The username of a Pro user
   * @param newAcceptanceDate The new acceptance date of the terms
   * @returns {Promise} A promise
   */
  public static async updateAcceptanceDate(username: string, newAcceptanceDate: string): Promise<any> {
    const requestData = {
      url: `${PUBLIC_ROOT_API}/Users/UpdateAcceptanceDate`,
      data: {
        username,
        newAcceptanceDate,
      },
    };

    await ApiService.put(requestData.url, requestData.data);
  }


  /**
   * Get route prefex corresponding to user SU
   * @returns {string} The route prefix
   */
  public static async getUserRoutePrefix() {
    return await ApiService.get(`${PUBLIC_ROOT_API}/users/route`, {
        handlerSuccessEnabled: false,
        handlerErrorEnabled: false,
      })
      .then((response: any) => {
        return response.data;
      })
      .catch(() => 'fr');
  }


  public static clearProData(): void {
    const filename = LocalStoreService.getItem(LocalStoreService.localItemKeys.followUpFilename);


    if (filename) {
      LocalStoreService.deleteItem(filename);
      LocalStoreService.deleteItem(LocalStoreService.localItemKeys.followUpFilename);
    }
  }
}
